import { TextField } from '@eleveo/components-react';
import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { useIntegrations } from '../../../app/IntegrationsProvider';
import { TEST_IDS } from '../../../constants/dataTestIds';
import { INTEGRATION_FORM_FIELDS } from '../../../scene/integrations/types';
import { composeValidators } from '../../../utils/validations/composeValidators';
import { max255Chars } from '../../../utils/validations/max255Chars';
import { handleMaxCharsError } from '../../../utils/validations/maxChars';
import { required } from '../../../utils/validations/required';

export const FieldIntegrationName: React.FC = () => {
  const { t } = useTranslation();
  const { isInReadOnlyMode } = useIntegrations();

  return (
    <Field name={INTEGRATION_FORM_FIELDS.name} validate={composeValidators(required, max255Chars)}>
      {({ input, meta }) => (
        <TextField
          isRequired
          isReadOnly={isInReadOnlyMode}
          label={t('myConfigurations.configuration.name')}
          className="w-full mbe-20"
          validationState={meta.touched && meta.invalid ? 'invalid' : 'valid'}
          errorMessage={handleMaxCharsError(meta.error, t, 255)}
          {...input}
          testId={TEST_IDS.inputConfigurationName}
        />
      )}
    </Field>
  );
};
